import Season1 from "./Season1";

export default [...Season1];
